const AccordionItem = () => {
	const accordionItems = Array.from(document.querySelectorAll('.accordion-item'));

	accordionItems.forEach(accordionItem => {
		let control = accordionItem.querySelector('.accordion-item-header');
		control.addEventListener('click', (e) => {
			let content = accordionItem.querySelector('.accordion-item-content');
			let animateFromHeight;
			let animateToHeight;

			let openAccordion = document.querySelector('.accordion-item--open');
			if (openAccordion && openAccordion != accordionItem) {
				openAccordion.firstElementChild.dispatchEvent(new Event('click'));
			}

			// get the accordion height
			content.classList.remove('accordion-item-content--animated');
			content.style.display = 'block'
			content.style.height = 'auto';
			let height = content.offsetHeight;

			// set the height manually, so that it can be animated
			if(accordionItem.classList.contains('accordion-item--open')) {
				animateFromHeight = height + 'px';
				animateToHeight = 0;
				control.setAttribute('aria-expanded', 'false');
				content.setAttribute('aria-hidden', 'true');
			} else {
				animateFromHeight = 0;
				animateToHeight = height + 'px';
				control.setAttribute('aria-expanded', 'true');
				content.setAttribute('aria-hidden', 'false');
			}

			accordionItem.classList.toggle('accordion-item--open');
			content.classList.add('accordion-item-content--animated');
			requestAnimationFrame(function() {
				content.style.height = animateFromHeight;

				requestAnimationFrame(function() {
					content.style.height = animateToHeight;
				});
			});
		});
	});

	// on resize update all open accordion heights
	window.addEventListener('resize', function() {
		accordionItems.forEach(accordionItem => {
			if(!accordionItem.classList.contains('accordion-item--open')) {
				return;
			}

			let content = accordionItem.querySelector('.accordion-item-content');
			let animateFromHeight;
			let animateToHeight;

			// get the accordion height
			content.classList.remove('accordion-item-content--animated');
			content.style.display = 'block'
			content.style.height = 'auto';
			let height = content.offsetHeight;

			// update the height
			content.style.height = height + 'px';
		});
	}, false);
};

export default AccordionItem;
